(function () {
  function getSelectedVariant() {
    const checked = document.querySelector('input[type="radio"][name^="Tamaño"]:checked');
    return checked ? checked.value.trim() : null;
  }

  function filterGallery() {
    const selected = getSelectedVariant();
    if (!selected) return;

    // Solo actuar dentro del media-gallery del producto, no en product cards
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const slides = gallery.querySelectorAll('slideshow-slide');
    let visibleCount = 0;

    slides.forEach(slide => {
      const img = slide.querySelector('img');
      if (!img) return;
      const alt = (img.alt || '').trim();

      if (alt === '8oz' || alt === '10oz') {
        if (alt === selected) {
          slide.style.display = '';
          visibleCount++;
        } else {
          slide.style.display = 'none';
        }
      } else {
        slide.style.display = '';
        visibleCount++;
      }
    });

    // Ocultar o mostrar flechas y dots según cuántos slides visibles hay
    const arrows = gallery.querySelector('slideshow-arrows');
    const controls = gallery.querySelector('slideshow-controls');
    if (arrows) arrows.style.display = visibleCount <= 1 ? 'none' : '';
    if (controls) controls.style.display = visibleCount <= 1 ? 'none' : '';

    // Ir al primer slide visible
    const firstVisible = gallery.querySelector('slideshow-slide:not([style*="display: none"])');
    if (firstVisible) {
      firstVisible.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
    }
  }

  // Escuchar cambio de variante
  document.addEventListener('change', (e) => {
    if (e.target.matches('input[type="radio"][name^="Tamaño"]')) {
      setTimeout(filterGallery, 50);
    }
  });

  // Ejecutar al cargar
  document.addEventListener('DOMContentLoaded', () => setTimeout(filterGallery, 150));
})();